import '../sass/index.scss';

const worldOfTapflo = document.getElementById('world-of-tapflo');
const branches = tpflBranches.branches;
const continents = document.querySelectorAll('g[id]'); 
const locations = document.querySelectorAll('[data-type="location"]');
const infoBranches = document.querySelectorAll('li[data-branch]'); // sub li elements under the location li elements
const draggableDiv = document.getElementById('draggable-div'); // the div that contains the svg map
const isMobile = window.innerWidth < 992; // check if the device is mobile  or not
 // Mobile Variables
const select = document.querySelector('.location-select__toggle');
const selectClose = document.querySelector('#tpfl_close');
const selectBackdrop = document.querySelector('.tpfl_container_backdrop');
const modal = document.querySelector('.info-container__modal');
const backBtn = document.getElementById('tpfl-back');

let isDragging = false; // flag to check if the map is being dragged
let isActiveCont = null; // the active continent
let isActiveBranch = null; // the active branch
let isActiveDot = null; // the active dot
let isActiveLocation = null; // the active location
let initialPos = { x: 0, y: 0 };
let pos1 = 0,
    pos2 = 0,
    pos3 = 0,
    pos4 = 0;

/**
 * Moves the continent to the center of the container worldOfTapflo.
 * @param {HTMLElement} continent - The continent element to be moved.
 */
function moveContinent(continent) {
    // find the center of the container worldOfTapflo
    const worldOfTapfloBbox = worldOfTapflo.getBoundingClientRect();
    const worldOfTapfloCenter = {
        x: worldOfTapfloBbox.left + worldOfTapfloBbox.width / 2,
        y: worldOfTapfloBbox.top + worldOfTapfloBbox.height / 2
    };
    
    // find the center of the continent
    const bbox = continent.getBoundingClientRect();
    const bboxCenter = {
        x: bbox.left + bbox.width / 2,
        y: bbox.top + bbox.height / 2
    };
    
    // calculate the new position
    let posX = worldOfTapfloCenter.x - bboxCenter.x;
    const posY = worldOfTapfloCenter.y - bboxCenter.y;

    const windowWidth = window.innerWidth;
    if (windowWidth >= 992 && windowWidth < 1366) {
        posX += 100; // adjust this value as needed
    }

    let currentPosX = parseFloat(getComputedStyle(draggableDiv).getPropertyValue('--currentPosX'));
    let currentPosY = parseFloat(getComputedStyle(draggableDiv).getPropertyValue('--currentPosY'));

    let posXToSet = posX;
    let posYToSet = posY;

    if (isNaN(currentPosX) || isNaN(currentPosY)) {
        // set the CSS variables
        draggableDiv.style.setProperty('--posX', `${posX}px`);
        draggableDiv.style.setProperty('--posY', `${posY}px`);
    } else {
        posXToSet = posX + currentPosX; 
        posYToSet = posY + currentPosY;

        draggableDiv.style.setProperty('--posX', `${posXToSet}px`);
        draggableDiv.style.setProperty('--posY', `${posYToSet}px`);
    }

    // remove the animation class if it exists
    if (draggableDiv.classList.contains('move')) {
        draggableDiv.classList.remove('move');
        void draggableDiv.offsetWidth; // force a reflow, flushing the CSS changes
    }
   
    draggableDiv.classList.add('move');  // add the animation class

    // wait for the animation to end
    draggableDiv.addEventListener('animationend', () => {
        // check if the current position is a number
        if (isNaN(currentPosX)) {
            currentPosX = 0;
        }
        if (isNaN(currentPosY)) {
            currentPosY = 0;
        }
        
        // adjust the new position
        const adjustedPosX = posX + currentPosX;
        const adjustedPosY = posY + currentPosY;
        
        // apply the transform
        draggableDiv.style.transform = `translate(${adjustedPosX}px, ${adjustedPosY}px)`;
        
        // update the current position
        draggableDiv.style.setProperty('--currentPosX', `${adjustedPosX}px`);
        draggableDiv.style.setProperty('--currentPosY', `${adjustedPosY}px`);

        draggableDiv.classList.remove('move');
    }, { once: true }); // run only once
}

/**
 * Changes the active continent and updates the UI accordingly.
 * @param {HTMLElement} continent - The continent element to set as active.
 */
function changeContinent(continent) {
    if (isActiveCont && continent === null) {
        isActiveCont.classList.remove('selected');
        isActiveCont = null;
        return;
    }
    if (isActiveCont && isActiveCont === continent) {
        return;
    } else {
        if (isActiveCont) {
            isActiveCont.classList.remove('selected');
        }
        isActiveCont = continent;
        if (isActiveCont) {
            isActiveCont.classList.add('selected');
        }
    }
}

/**
 * Changes the active location and performs necessary UI updates.
 * @param {HTMLElement} location - The location element to set as active.
 */
function changeLocation(location, type = null) {   
    if (isActiveLocation && isActiveLocation === location && !isActiveLocation.children[1].classList.contains('active')) { 
        isActiveLocation.children[1].classList.add('active');
        return;
    } else if ((type != 'branch') && isActiveLocation && isActiveLocation === location) {
        if (isActiveBranch) {
            changeDot(null);
            changeBranch(null);
            showHiddenBrnaches();
        }
        if (isActiveLocation && isActiveLocation.children[1].classList.contains('active')) {
            isActiveLocation.children[1].classList.remove('active');
        }
        return;
    } else {
        if (isActiveLocation) {
            isActiveLocation.classList.remove('selected');
            isActiveLocation.children[1].classList.remove('active');
            showHiddenBrnaches();
        }
        isActiveLocation = location;
        if (isActiveLocation === null) {
            return;
        }
        isActiveLocation.classList.add('selected');
        isActiveLocation.children[0].classList.remove('muted');
        isActiveLocation.children[1].classList.add('active');
        locations.forEach( loc => {
            if (loc !== isActiveLocation) {
                loc.children[0].classList.add('muted');
            }
        });
    }

    if (isActiveDot != null && isActiveDot.dataset.location != location.dataset.location) {
        changeDot(null);
        changeBranch(null);
    }

    backBtn.style.display = 'flex';
    moveContinent(document.getElementById(isActiveLocation.dataset.location));
}

/**
 * Changes the active dot and updates its class.
 * If the dot parameter is null, it removes the 'selected' class from the active dot.
 * If the dot parameter is the same as the active dot, it does nothing.
 * If the dot parameter is different from the active dot, it updates the active dot and adds the 'selected' class.
 *
 * @param {HTMLElement} dot - The dot element to be set as the active dot.
 */
function changeDot(dot) {
    if (isActiveDot && dot === null) {
        isActiveDot.classList.remove('selected');
        isActiveDot = null;
        return;
    }

    if (isActiveDot && isActiveDot === dot) {
        return;
    } else {
        if (isActiveDot) {
            isActiveDot.classList.remove('selected');
        }
        isActiveDot = dot;
        if (isActiveDot) {
            isActiveDot.classList.add('selected');
        }
    }
}

/**
 * Shows hidden branches by setting their display property to an empty string.
 */
function showHiddenBrnaches() {
    const locationBranches = document.querySelectorAll('li.branch[style*="display: none"]');
    locationBranches.forEach(branch => {
        branch.style.display= '';
    });
}

/**
 * Changes the active branch and updates the UI accordingly.
 * 
 * @param {HTMLElement} branch - The branch element to be set as active.
 */
function changeBranch(branch) {
    if (isActiveBranch && branch === null) {
        isActiveBranch.classList.remove('selected');
        isActiveBranch = null;
        return;
    }
    if (isActiveBranch && isActiveBranch === branch) {
        if (isActiveBranch) {
            isActiveBranch.classList.remove('selected');
            showHiddenBrnaches();
            isActiveBranch = null;
        }
        return;
    }  else {
        if (isActiveBranch) {
            isActiveBranch.classList.remove('selected');
            showHiddenBrnaches();
        }
        isActiveBranch = branch; // update Active Branch
        isActiveBranch.classList.add('selected'); // add selected class to the active branch
        const location = isActiveBranch.parentNode;
        const locationBranches = location.querySelectorAll('li.branch');
        // get all within the location
        if (isMobile) {
            modal.classList.add('active');
            // remove the optionslist adn backdrop
            select.classList.remove('active');
            selectBackdrop.classList.remove('active');
            // close all modal content and open the selected one
            modal.querySelectorAll('.info-container__modal--content').forEach(content => {
                content.classList.remove('selected');
            });
            modal.querySelector(`[data-branch="${isActiveBranch.dataset.branch}"]`).classList.add('selected');
            moveContinent(document.getElementById(isActiveBranch.dataset.location));
        } else {
            locationBranches.forEach(branch => {
                if (branch !== isActiveBranch) {
                    branch.style.display = "none";
                }
            });
        }
    }
}

if (worldOfTapflo) {
    continents.forEach(continent => {
        const target = document.querySelector(`[data-location="${continent.id}"]`);
        continent.addEventListener('mouseover', () => {
            continent.classList.add('active');
            target.classList.add('active');
        });
        continent.addEventListener('mouseout', () => {
            continent.classList.remove('active');
            target.classList.remove('active');
        });
        continent.addEventListener('click', () => {
            if(isMobile) {
                modal.classList.remove('active');
            }
            if (!isDragging) {
                if (isActiveCont && isActiveCont === continent) {
                    showHiddenBrnaches();
                    changeBranch(null);
                    changeDot(null);
                } else {
                    changeContinent(continent);
                    changeLocation(document.querySelector(`li.location[data-location="${isActiveCont.id}"]`));
                }
            }
        });
    });

    if (branches) {
        for (let i = 0; i < branches.length; i++) {
            const branch = branches[i];
            const branchID = branch.taxonomy[0]?.name;
            if (!branchID) {
                continue;
            }
            const capitalizedName = branchID.replace(/\b\w/g, l => l.toUpperCase());
            const formattedName = capitalizedName.replace(/-| /g, '');
            const target = document.getElementById(formattedName);
            const child = target.children[0];
            const dot = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
            const bbox = target.getBBox();
            const x = branch.x_value ? parseFloat(branch.x_value) + (bbox.x + bbox.width / 2) : bbox.x + bbox.width / 2;
            const y = branch.y_value ? parseFloat(branch.y_value) + (bbox.y + bbox.height / 2) : bbox.y + bbox.height / 2;
            dot.setAttribute('cx', x);
            dot.setAttribute('cy', y);
            dot.setAttribute('r', 5);
            dot.setAttribute('fill', 'red');
            dot.setAttribute('data-location', formattedName);
            dot.setAttribute('data-branch', branch.post_name);
            dot.setAttribute('data-type', 'branch');
            dot.classList.add('location');
            child.appendChild(dot);
        }

        const dots = document.querySelectorAll('circle[data-branch]');

        dots.forEach(dot => {
            const targetBranch = document.querySelector(`li[data-branch="${dot.dataset.branch}"]`);
            const targetLocation = document.querySelector(`li.location[data-location="${dot.dataset.location}"]`);
            dot.addEventListener('mouseover', () => {
                targetBranch.classList.add('active');
            });
            dot.addEventListener('mouseout', () => {
                targetBranch.classList.remove('active');
            });
            dot.addEventListener('click', (e) => {
                e.stopPropagation();
                changeDot(dot);
                changeLocation(targetLocation, 'branch');
                changeContinent(document.getElementById(isActiveLocation.dataset.location));
                changeBranch(targetBranch);
         
            });
        });
    }

    locations.forEach(location => {
        const target = location.dataset.location;
        location.addEventListener('mouseover', () => {
            location.classList.add('active');
            const targetElement = document.getElementById(target);
            if (targetElement) {
                targetElement.classList.add('active');
            }
        });
        location.addEventListener('mouseout', () => {
            location.classList.remove('active');
            const targetElement = document.getElementById(target);
            if (targetElement) {
                targetElement.classList.remove('active');
            }
        });
        const locationToggle = location.querySelector('.location-toggle');
        if (locationToggle) {
            locationToggle.addEventListener('click', () => {
                if (isMobile) {
                    // close the select and remove backdrop
                    select.classList.remove('active');
                    selectBackdrop.classList.remove('active');
                }
                changeLocation(location);
                const activeLocationElement = document.getElementById(isActiveLocation.dataset.location);
                if (activeLocationElement) {
                    changeContinent(activeLocationElement);
                }
            });
        }
    });

    if (infoBranches) {
        infoBranches.forEach(branch => {
            const target = document.querySelector(`circle[data-branch="${branch.dataset.branch}"]`);
            branch.addEventListener('mouseover', () => {
                branch.classList.add('active');
                target.classList.add('active');
            });
            branch.addEventListener('mouseout', () => {
                branch.classList.remove('active');
                target.classList.remove('active');
            });
            branch.addEventListener('click', () => {
                changeBranch(branch);
                if (isActiveBranch) {
                    changeDot(document.querySelector(`circle[data-branch="${isActiveBranch.dataset.branch}"]`));
                }
            });
        });
    }

    draggableDiv.addEventListener('mousedown', dragMouseDown);
    draggableDiv.addEventListener('touchstart', dragMouseDown);

    function dragMouseDown(e) {
        let originalEvent = e;
        e = e.type === 'touchstart' ? e.touches[0] : e;
        if (originalEvent.stopPropagation) {
            originalEvent.stopPropagation();
        }
        initialPos = { x: e.clientX, y: e.clientY };
        pos3 = e.clientX;
        pos4 = e.clientY;
        document.addEventListener('mouseup', closeDragElement);
        document.addEventListener('touchend', closeDragElement);
        document.addEventListener('mousemove', elementDrag);
        document.addEventListener('touchmove', elementDrag);
    }

    function elementDrag(e) {
        let originalEvent = e;
        e = e.type === 'touchmove' ? e.touches[0] : e;
        if (originalEvent.stopPropagation) {
            originalEvent.stopPropagation();
        }
        const currentPos = { x: e.clientX, y: e.clientY };
        const movedEnough = Math.abs(currentPos.x - initialPos.x) > 5 || Math.abs(currentPos.y - initialPos.y) > 5;
        if (movedEnough && !isDragging) {
            isDragging = true;
        }
        pos1 = pos3 - e.clientX;
        pos2 = pos4 - e.clientY;
        pos3 = e.clientX;
        pos4 = e.clientY;
        draggableDiv.style.top = (draggableDiv.offsetTop - pos2) + "px";
        draggableDiv.style.left = (draggableDiv.offsetLeft - pos1) + "px";
    }

    function closeDragElement() {
        setTimeout(() => {
            isDragging = false;
        }, 0);
        document.removeEventListener('mouseup', closeDragElement);
        document.removeEventListener('touchend', closeDragElement);
        document.removeEventListener('mousemove', elementDrag);
        document.removeEventListener('touchmove', elementDrag);
    }

    if (isActiveCont) {
        backBtn.style.display = 'flex';
    } else {
        backBtn.style.display = 'none';
    }

    if (backBtn) {
        backBtn.addEventListener('click', () => {
            if (isActiveBranch) {
                console.log('branch');
                changeBranch(null);
                changeDot(null);
                showHiddenBrnaches();
            } else if (isActiveLocation) {
                console.log('location');
                changeContinent(null);
                changeLocation(null);
                document.querySelectorAll('.location-toggle.muted').forEach(toogle => {
                    toogle.classList.remove('muted');
                });
                backBtn.style.display = 'none';
            }
        });
    }
}

if (worldOfTapflo && isMobile) {
    // on first load move europe to the center
    const europe = document.getElementById('Europe');
    moveContinent(europe);

    // Mobile Functions
    /**
     * Toggles the active state of the select element and its backdrop.
     */
    function toggleSelect() {
        select.classList.toggle('active');
        selectBackdrop.classList.toggle('active');
    }

    /**
     * Toggles the modal and optionally toggles the branch content.
     * @param {string} branch - The branch to toggle the content for.
     */
    function toggleModal(branch) {
        modal.classList.toggle('active');
        if (branch && modal.classList.contains('active')) {
            toggleBranchContent(branch);
        }
    }

    /**
     * Toggles the visibility of branch content.
     * @param {HTMLElement} branch - The branch element to toggle the content for.
     */
    function toggleBranchContent(branch) {
        let ativeContent = modal.querySelector('.selected');
        if (branch) {
            let content = modal.querySelector(`[data-branch="${branch.dataset.branch}"]`);
            content.classList.toggle('selected');
        } else {
            ativeContent.classList.toggle('selected');
        }
    }

    const modalClose = document.querySelector('.info-container__modal--close');
    modalClose.addEventListener('click', () => {
        toggleModal(); // close modal
        toggleBranchContent(); // close branch content
        changeBranch(null); // reset active branch
        changeDot(null); // reset active dot and selcted dot
        changeContinent(null); // reset active continent
    });

    // open and close the select
    if (select) {
        select.addEventListener('click', () => {
            toggleSelect();
        });
    }

    // close the select
    if (selectClose) {
        selectClose.addEventListener('click', () => {
            toggleSelect();
        });
    }

    // close the select when clicking outside of its boundaries
    if (selectBackdrop) {
        selectBackdrop.addEventListener('click', () => {
            toggleSelect();
        });
    }
}